import './backgrounds.css'
import BKGRND from './Background/App.js'

const app = new BKGRND()